<template>
  <div id="logViewerDiv">
    <ul id="logs">
      <li v-for="(log, i) in logStore.logList" :key="i">{{log}}</li>
    </ul>
  </div>
</template>

<script setup>
import { useLogStore } from '../../stores/LogStore';


const logStore = useLogStore()

</script>

<style>
  #logViewerDiv {
    overflow-x: auto;
    overflow-y: scroll;
    flex-direction: column-reverse;
    display: flex;
    height: 800px
  }
</style>